import type { FormSchema } from './schema';
import type {
  ItemDto,
  SectionDto,
} from '@/api/hooks/useUpdateFacilityInformation/types';
import {
  BUSINESS_DETAILS_SECTION_ID,
  BUSINESS_DETAILS_SECTION_TITLE,
} from '@pages/Facilities/Sections/Details/types';
import type { UseFormSetValue } from 'react-hook-form';

export const FieldsData = {
  LicenseNumber: { label: 'License Number', name: 'license-number' },
  SoftwareName: {
    label: 'Name of software used for inventory (POS)',
    name: 'name-software',
  },
  NumberEmployees: {
    label: 'Total number of employees',
    name: 'number-employees',
  },
  DispensarySquare: {
    label: 'Square feet of dispensary',
    name: 'dispensary-square',
  },
  EstimateArrivalDate: {
    label: 'Estimated Arrival Date of license',
    name: 'estimated-arrival-license-date',
  },
} as const;

export const SOFTWARE_LICENSE_PAGE_ID = 'software-licence-page';

export function getNormalizedData(facilityData: FormSchema): SectionDto {
  let items: ItemDto[] = [];

  const {
    'license-number': licenseNumber,
    'name-software': nameSoftware,
    'number-employees': numberEmployee,
    'dispensary-square': dispensarySquare,
    'estimated-arrival-license-date': estimatedArrivalDate,
  } = facilityData;

  items = items.concat([
    {
      id: FieldsData.LicenseNumber.name,
      type: 'QUESTION',
      question: FieldsData.LicenseNumber.label,
      answer: licenseNumber ?? '',
    },
    {
      id: FieldsData.SoftwareName.name,
      type: 'QUESTION',
      question: FieldsData.SoftwareName.label,
      answer: nameSoftware || '',
    },
    {
      id: FieldsData.NumberEmployees.name,
      type: 'QUESTION',
      question: FieldsData.NumberEmployees.label,
      answer: numberEmployee || '',
    },
    {
      id: FieldsData.DispensarySquare.name,
      type: 'QUESTION',
      question: FieldsData.DispensarySquare.label,
      answer: dispensarySquare || '',
    },
    {
      id: FieldsData.EstimateArrivalDate.name,
      type: 'QUESTION',
      question: FieldsData.EstimateArrivalDate.label,
      answer: estimatedArrivalDate || '',
    },
  ]);

  const allItems = items.filter((item) => !!item.answer);

  return {
    id: BUSINESS_DETAILS_SECTION_ID,
    title: BUSINESS_DETAILS_SECTION_TITLE,
    page: {
      id: SOFTWARE_LICENSE_PAGE_ID,
      title: 'Business Detail Section - Cannabis License',
      items: allItems,
    },
  };
}

export function setSoftwareLicenseValues(
  detailType: SectionDto,
  setValues: UseFormSetValue<FormSchema>,
): void {
  detailType.page.items.forEach((item) => {
    setValues(item.id as keyof FormSchema, item.answer);
  });
}
